<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-holiday-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupHolidayContainerView: () => import('@/components/hris/setup/holiday/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Setup Holiday',
      }
    },
  }
</script>
